module.exports = __webpack_public_path__ + "static/img/designnew.84476224.png";